import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const getToken = () => localStorage.getItem("token");

const useRoleFunctions = () => {
  const [payloads, setPayloads] = useState(() => {
    const token = getToken();
    return token ? jwtDecode(token) : {};
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const token = getToken();
      setPayloads(token ? jwtDecode(token) : {});
    };

    // Listen for localStorage changes
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const rolesArray = payloads?.realm_access?.roles || [];

  const hasRequiredRoles = (requiredRoles) => {
    if (!Array.isArray(requiredRoles)) {
      console.error("Invalid requiredRoles array");
      return false;
    }
    return requiredRoles.every((role) => rolesArray.includes(role));
  };

  return { payloads, rolesArray, hasRequiredRoles };
};

export default useRoleFunctions;
